import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, ArrowRight, Crown, Zap, Star, Users } from "lucide-react";

import { NavbarLight } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";

const tierIcons = {
  founding: Zap,
  core: Users,
  premium: Star,
  elite: Crown,
};

const tierColors = {
  founding: "text-[#14B8A6]",
  core: "text-[#2C4A3B]",
  premium: "text-[#D4A017]",
  elite: "text-[#D4A017]",
};

const MembershipSuccess = () => {
  const [searchParams] = useSearchParams();
  const tier = searchParams.get("tier") || "member";
  const cycle = searchParams.get("cycle") || "annual";

  const Icon = tierIcons[tier] || CheckCircle;
  const color = tierColors[tier] || "text-[#2C4A3B]";

  const tierNames = {
    founding: "Founding Member",
    core: "Core Member",
    premium: "Premium Member",
    elite: "Elite Member",
  };

  return (
    <div className="min-h-screen bg-[#EFEDE5]">
      <NavbarLight />

      <section className="py-20 px-6 md:px-12">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <div className="w-20 h-20 rounded-full bg-[#2C4A3B] flex items-center justify-center mx-auto mb-6">
              <Icon className={`w-10 h-10 ${tier === "founding" ? "text-[#14B8A6]" : "text-[#D4A017]"}`} />
            </div>
            <CheckCircle className="w-12 h-12 text-[#2C4A3B] mx-auto mb-4" />
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#1A1915] mb-4" data-testid="membership-success-title">
              Welcome to EK Valleys!
            </h1>
            <p className="text-xl text-[#5C5A52] mb-2">
              You're now a <span className={`font-bold ${color}`}>{tierNames[tier] || "Member"}</span>
            </p>
            <p className="text-[#5C5A52]">
              Billing: {cycle === "annual" ? "Annual" : "Monthly"}
            </p>
          </div>

          <div className="bg-[#F7F6F2] border-2 border-[#D1CFC5] rounded-xl p-8 mb-8">
            <h2 className="font-heading text-2xl font-semibold text-[#1A1915] mb-4">What happens next?</h2>
            <ul className="text-left text-[#5C5A52] space-y-3">
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-[#2C4A3B] mt-0.5 flex-shrink-0" />
                <span>Your membership is now active and your benefits are ready to use.</span>
              </li>
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-[#2C4A3B] mt-0.5 flex-shrink-0" />
                <span>A confirmation email will be sent to your registered email.</span>
              </li>
              {tier === "founding" && (
                <li className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#14B8A6] mt-0.5 flex-shrink-0" />
                  <span className="font-medium text-[#1A1915]">Your 20% lifetime discount is locked in. This applies to all future tier upgrades.</span>
                </li>
              )}
              <li className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5 text-[#2C4A3B] mt-0.5 flex-shrink-0" />
                <span>List your business in the directory to start getting visibility.</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/list-business">
              <Button className="bg-[#2C4A3B] hover:bg-[#1A2F23] text-white font-semibold px-8" data-testid="list-business-from-success">
                List Your Business
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/directory">
              <Button variant="outline" className="font-semibold px-8" data-testid="browse-directory-from-success">
                Browse Directory
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MembershipSuccess;
